<app-template *ngIf="!isIEOrEdge">

    <!-- FAD MASIVO DESKTOP -->
    <div class="fad-desktop" *ngIf=" isMobile === false && isTablet === false ">

        <div class="principal-section">
            <div class="side image-background">
                <div class="data">
                    <div class="title">
                        <h1><p>Comienza a <span>firmar</span> ya<br><span>con FAD®</span></p></h1>
                    </div>
                    <div class="description">
                        <h2><p>
                            Firma Autógrafa Digital®
                        </p></h2>
                        <img width="300px" src="assets/images/FAD-ISO-27001.png" alt="ISO 27001">
                    </div>
                    <div class="actions black" id="video_romantico" (click)="openVideo()">
                        <div class="preview">
                            <p>
                                ¿QUÉ ES FAD?
                            </p>
                        </div>
                        <img src="assets/images/icon_play.png" alt="Play">
                    </div>
                </div>
            </div>
            <div class="img-principal"></div>
        </div>

        <div class="banner-mapa">
            <img width="100%" height="auto" src="assets/images/mapa_fad.png" alt="">
            <div class="title">
                <p>Países que ya firman con <span>FAD®</span></p>
            </div>
        </div>

        <div class="principal-section">
            <div class="img-principal2"></div>
            <div class="side image-background">
                <div class="data">
                    <div class="title">
                        <p>Somos la plataforma de firma
                            <br><br><span>MÁS SEGURA DEL MUNDO</span></p>
                    </div>
                </div>
            </div>
        </div>

        <div class="principal-section">
            <div class="img-principal3">
                <div class="wraper">
                    <div class="data">
                        <div class="description">
                            <p>
                                <span>Crea una cuenta sin<br>compromiso</span>, conoce FAD® y…<br><br>
                            </p>
                        </div>
                        <div class="title">
                            <p>¡Recibe<br>
                                <span>3 firmas GRATIS!</span><br>
                            </p>
                        </div>
                        <div class="actions red" (click)="freeTest()">
                            <div class="preview">
                                <p>
                                    ¡CREA TU CUENTA AHORA!
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="side imagen-prin">
                <img src="assets/images/firma-prin3.png" alt="">
            </div>
        </div>

        <div class="sign-any-document">
            <div class="max-width">
                <p>
                    <span>Firma cualquier documento desde tu smartphone,</span> <br>
                    sin importar en donde te encuentres. <br>
                    100% segura. 100% atribuíble. 100% legal.
                </p>
            </div>
        </div>

        <div class="products">
            <div class="container max-width">
                <div class="product">
                    <mat-card>
                        <div class="image">
                            <img mat-card-image src="assets/images/fad_personal.png" alt="FAD Personal">
                            <div class="text">
                                <p>FAD® personal</p>
                            </div>
                        </div>
                        <mat-card-content>
                            <p class="description">
                                <strong>Incluye proceso patentado:</strong><br>
                                Videofirma, videoacuerdo, constancia de conservación
                                <br>
                                <strong>Soporte:</strong><br>
                                N1 Call center de Lunes a Viernes de 8am a 8pm.
                                <br>
                                <strong>Incluye:</strong><br>
                                Sólo app nativa (iOS y Android)
                                <br><strong style="font-size: 18px">No incluye opción a compra de SDK o API</strong>
                            </p>


                        </mat-card-content>
                    </mat-card>
                </div>

                <div class="product">
                    <mat-card>
                        <div class="image">
                            <img mat-card-image src="assets/images/fad_empresa.png" alt="FAD Empresa">
                            <div class="text">
                                <p>FAD® empresa</p>
                            </div>
                        </div>
                        <mat-card-content>
                            <p class="description">
                                <strong>Incluye proceso patentado:</strong><br>
                                Videofirma, videoacuerdo, constancia de conservación<br>
                                <strong>Soporte:</strong><br>
                                N1 Call center de Lunes a Viernes de 8am a 8pm. (N2 con costo extra)
                                <br>
                                <strong>Incluye:</strong><br>
                                App nativa (iOS y Android) opción a adquirir App Web, SDK y API.
                            </p>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
        </div>

        <div class="pricing-list">
            <div class="container max-width">
                <div class="panel">
                    <mat-expansion-panel id="ver_plan_persona_inicio" hideToggle (click)="addDataLayerClicProducto(1)">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <p>VER PLANES Y CONTRATAR</p>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="content-panel">

                        </div>
                    </mat-expansion-panel>
                </div>
                <div class="panel">
                    <mat-expansion-panel id="ver_plan_empresa_inicio" hideToggle (click)="addDataLayerClicProducto(2)">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <p>VER PLANES Y CONTRATAR</p>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="content-panel">
                        </div>
                    </mat-expansion-panel>
                </div>
            </div>
        </div>

        <div class="principal-section">
            <div class="img-principal4">
                <div class="wraper">
                    <img width="140%" src="assets/images/clientes-pc.png" alt="">
                </div>
            </div>
            <div class="imagen-prin1">
                <div class="description">
                    <p>
                        Para <span>configurar un documento</span> para firmar con FAD
                    </p>
                </div>
                <br>
                <div class="title">
                    <p>sólo debes ingresar a:<br>
                        <span><a href="https://clientes.firmaautografa.com/login" target="_blank">clientes.firmaautografa.com</a></span>
                    </p>
                </div>
            </div>
        </div>

        <div class="use-cases max-width">
            <p class="title max-width">
                Conoce cómo <span>FAD®</span> puede ayudar a <span>dar seguridad y certeza legal</span> a cualquiera de
                los <span>procesos, acuerdos y documentos</span> de diferentes industrias </p>
            <div class="contain-absolute">
                <div><img width="100%" src="assets/images/_DSC6336.png" alt=""></div>
                <div class="text">
                    <p><span>Bancos Adquiriente</span></p>
                    <p>Firma para afiliación móvil de comercios con videofirma, videoacuerdo,
                        geolocalización y constancia de conservación avalada por las autoridades.</p>
                    <hr>
                </div>
                <div><img width="100%" src="assets/images/_DSC3528.png" alt=""></div>
                <div class="text">
                    <p><span>Créditos al consumo</span></p>
                    <p>Firma digital para colocación de créditos al consumo con videofirma,
                        videoacuerdo, geolocalización y constancia de
                        conservación avalada por las autoridades.</p>
                    <hr>
                </div>
                <div><img width="100%" src="assets/images/_DSC4225.png" alt=""></div>
                <div class="text">
                    <p><span>Consulta de historial crediticio</span></p>
                    <p>Firma digital para autorización de consulta de historial crediticio con
                        videofirma, videoacuerdo, geolocalización y constancia de conservación
                        avalada por las autoridades.</p>
                    <hr>
                </div>
                <div><img width="100%" src="assets/images/_DSC6689.png" alt=""></div>
                <div class="text">
                    <p><span>Tarjeta de crédito</span></p>
                    <p>Firma digital para contratación de tarjetas de crédito con videofirma,
                        videoacuerdo, geolocalización y constancia de conservación avalada
                        por las autoridades.</p>
                    <hr>
                </div>
                <div><img width="100%" src="assets/images/_DSC5357.png" alt=""></div>
                <div class="text">
                    <p><span>Pagarés</span></p>
                    <p>Firma digital para creación,endoso y cancelación de pagarés con
                        videofirma, video de aceptación del acuerdo, geolocalización y
                        constancia de conservación avalada por las autoridades.</p>
                    <hr>
                </div>
                <div><img width="100%" src="assets/images/_DSC660.png" alt=""></div>
                <div class="text">
                    <p><span>Recetas médicas</span></p>
                    <p>Firma digital por parte del médico, para envío de recetas certificadas a
                        distancia, con video firma, videoacuerdo, geolocalización y constancia
                        de conservación avalada por un tercero.</p>
                    <hr>
                </div>
                <div><img width="100%" src="assets/images/_DSC5370.png" alt=""></div>
                <div class="text">
                    <p><span>Firma de contratos laborales</span></p>
                    <p>Firma de contratos de alta o terminación de relación laboral, vacaciones,
                        confidencialidad, entre muchos otros. Incluye videofirma y constancia
                        de conservación avalada por las autoridades.</p>
                    <hr>
                </div>
            </div>
            <p class="title max-width">
                Descubre todos los casos de uso de <span>FAD®</span> y conviértete en un
                <span>embajador de la transformación digital</span> en tu empresa.
            </p>
            <div class="contain-cases-button">
                <p class="title max-width">
                    VER TODO LO QUE <br><span>PUEDO HACER CON FAD®</span></p>
                <div id="ver_casos_usos" class="more-cases" (click)="moreUseCases()">
                    <p>VER MÁS CASOS DE USO</p>
                </div>
            </div>
        </div>

        <div class="steps">
            <p class="title max-width">
                ¿Cómo puedes <span>adquirir el plan de firmas</span> que mejor <br>
                se adapte a tus necesidades, en sólo 4 pasos?
            </p>
            <div class="steps-container max-width">
                <div class="step">
                    <div class="header">
                        <div class="number">
                            <p>01</p>
                            <img src="assets/images/Rectangle.png" alt="Rectangle">
                        </div>
                        <div class="name">
                            <p>Elige entre</p>
                        </div>
                    </div>
                    <div class="content">
                        <p>
                            FAD® Personal o <br> FAD® Empresa
                        </p>
                        <img src="assets/images/step_1.png" alt="Step image">
                    </div>
                </div>

                <div class="step">
                    <div class="header">
                        <div class="number">
                            <p>02</p>
                            <img src="assets/images/Rectangle.png" alt="Rectangle">
                        </div>
                        <div class="name">
                            <p>Selecciona</p>
                        </div>
                    </div>
                    <div class="content">
                        <p>
                            El tipo de suscripción que mejor se adapte a tu negocio o empresa.
                        </p>
                        <img src="assets/images/step_2.png" alt="Step image">
                    </div>
                </div>

                <div class="step">
                    <div class="header">
                        <div class="number">
                            <p>03</p>
                            <img src="assets/images/Rectangle.png" alt="Rectangle">
                        </div>
                        <div class="name">
                            <p>Indica método <br> de pago</p>
                        </div>
                    </div>
                    <div class="content">
                        <p>
                            · Tarjeta de débito <br>
                            · Tarjeta de crédito <br>
                        </p>
                        <img src="assets/images/step_4.png" alt="Step image">
                    </div>
                </div>

                <div class="step">
                    <div class="header">
                        <div class="number">
                            <p>04</p>
                            <img src="assets/images/Rectangle.png" alt="Rectangle">
                        </div>
                        <div class="name">
                            <p>Disfruta tu plan</p>
                        </div>
                    </div>
                    <div class="content">
                        <p>
                            <strong>Si quieres agregar funcionalidades extra,
                                contactáctanos vía WhatsApp...</strong>
                        </p>
                        <img src="assets/images/step_3.png" alt="Step image">
                    </div>
                </div>

            </div>
        </div>

        <div class="complement">
            <p class="title max-width">
                <span>Complementa tu plan de firmas digitales con las siguientes</span><br>
                <span>funcionalidades extra (Add-Ons)</span>, las cuales te ayudarán a crear una
                solución perfecta para ti:
            </p>
            <div class="complements max-width">

                <div class="item">
                    <img src="assets/images/otp_whatsap.png" alt="Videoacuerdo">
                    <div class="data">
                        <p class="title">OTP vía WhatsApp</p>
                        <p class="description">Envío de código de un sólo uso por WhatsApp, para que el firmante abra
                            el documento a firmar en la app móvil o web</p>
                    </div>
                </div>

                <div class="item">
                    <img src="assets/images/version_web.png" alt="Videoacuerdo">
                    <div class="data">
                        <p class="title">Versión WEB</p>
                        <p class="description">El firmante puede realizar la firma de documentos desde cualquier
                            navegador móvil sin descargar ninguna aplicación</p>
                    </div>
                </div>

                <div class="item">
                    <img src="assets/images/foto_ine.png" alt="Videoacuerdo">
                    <div class="data">
                        <p class="title">Captura de identificación</p>
                        <p class="description">Fotografía de la identificación por ambos lados</p>
                    </div>
                </div>

                <div class="item">
                    <img src="assets/images/blockchain.png" alt="Videoacuerdo">
                    <div class="data">
                        <p class="title">Constancia de conservación en Blockchain</p>
                        <p class="description">Constancia escrita en Ethereum que garantiza que el documento firmado no será alterado.</p>
                    </div>
                </div>

                <div class="item">
                    <img src="assets/images/compara_videoacuerdo.png" alt="Videoacuerdo">
                    <div class="data">
                        <p class="title">Comparación de videoacuerdo</p>
                        <p class="description">Comparación entre el rostro del firmante durante el videoacuerdo y la
                            foto que aparece en la identificación</p>
                    </div>
                </div>

                <div class="item">
                    <img src="assets/images/compara_videofirma.png" alt="Videoacuerdo">
                    <div class="data">
                        <p class="title">Comparación de videofirma</p>
                        <p class="description">Comparación entre el rostro del firmante durante la videofirma y la foto
                            que aparece en la identificación</p>
                    </div>
                </div>

                <div class="item">
                    <img src="assets/images/comparacion_firma.png" alt="Videoacuerdo">
                    <div class="data">
                        <p class="title">Comparación de firma</p>
                        <p class="description">Comparación entre la firma plasmada en la identificación y la firma
                            hecha con el dedo o lápiz óptico</p>
                    </div>
                </div>

                <div class="item">
                    <img src="assets/images/notificacion.png" alt="Videoacuerdo">
                    <div class="data">
                        <p class="title" style="color: #a80a34;">Consideraciones importantes</p>
                        <p class="description">
                            1. Para realizar las comparaciones de video acuerdo, videofirma y firma,
                            es necesario adquirir la Captura de identificación. <br>
                            2. Para la compra de Add-Ons solicítalos con tu asesor de ventas
                            con costo extra.
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="legal-compliance">
            <div class="backdrop"></div>
            <div class="text">
                <p>La Firma Autógrafa Digital® <span>cumple con las leyes <br>
          de UNCITRAL (ONU) y el nuevo reglamento <br>
          eIDAS, US ESIGN y UETA & ESIGN Act</span>, entre otros <br> ordenamientos</p>
                <div id="ver_cumplimieno_legal" class="button-more"
                     [routerLink]="['/cumplimiento-juridico-de-la-firma-digital']">
                    <p>VER MÁS SOBRE CUMPLIMIENTO LEGAL</p>
                </div>
            </div>
        </div>

        <div class="characteristics">
            <p class="title max-width">
                <span>FAD®</span> es la <span>firma digital más utilizada en Latinoamérica</span>, ya que cuenta
                con los siguientes diferenciadores únicos:
            </p>
        </div>

        <div class="characteristics-image max-width">
            <div class="contain-absolute">
                <div class="column white">
                    <mat-card>
                        <mat-card-content>
                            <div class="item">
                                <p class="principal">
                                    3 minutos
                                </p>
                                <p class="important">
                                    es el tiempo que tardas en firmar un <br> documento con FAD®
                                </p>
                            </div>
                            <div class="item">
                                <p class="principal">
                                    100% legal
                                </p>
                                <p class="important">
                                    la única firma digital probada en <br> juzgados
                                </p>
                            </div>
                            <div class="item">
                                <p class="principal">
                                    Ahorra 90%
                                </p>
                                <p class="important">
                                    del tiempo invertido en tus procesos <br> de firma
                                </p>
                            </div>
                            <div class="important">
                                <div class="more-cases" (click)="freeTest()">
                                    <p>QUIERO UNA PRUEBA GRATUITA</p>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
                <div class="column"></div>
            </div>
            <div class="white"></div>
            <div class="image">
                <img src="assets/images/diferenciadores.png" alt="Características">
            </div>
        </div>

        <div class="are-you-ready">
            <p class="title max-width">
                ¿Estás listo para <span>comenzar a firmar documentos</span><br>
                <span>digitalmente con FAD®</span>? Selecciona la opción que mejor <br>
                se adapte a tus necesidades:
            </p>
            <div class="options">
                <div class="container max-width">
                    <div class="item">
                        <img src="assets/images/fad_personal_thin.png" alt="FAD personal">
                        <div class="contain">
                            <p class="title">
                                FAD® personal
                            </p>
                            <p class="description">
                                <strong>Incluye proceso patentado:</strong><br>
                                Videofirma, Videoacuerdo, Constancia de conservación
                                <br>
                                <strong>Soporte:</strong><br>
                                N1 Call center de Lunes a Viernes de 8am a 8pm.
                                <br>
                                <strong>Incluye:</strong><br>
                                Sólo app nativa (iOS y Android)
                                <br><strong style="font-size: 18px">No incluye opción a compra de SDK o API</strong>
                                <br>
                                <br>
                            </p>
                        </div>
                    </div>
                    <div class="item">
                        <img src="assets/images/fad_empresa_thin.png" alt="FAD personal">
                        <div class="contain">
                            <p class="title">
                                FAD® empresa
                            </p>
                            <p class="description">
                                <strong>Incluye proceso patentado:</strong><br>
                                Videofirma, Videoacuerdo, Constancia de conservación
                                <br>
                                <strong>Soporte:</strong><br>
                                N1 Call center de Lunes a Viernes de 8am a 8pm. (N2 con costo extra)
                                <br>
                                <strong>Incluye:</strong><br>
                                App nativa (iOS y Android) opción a adquirir App Web, SDK y API.
                            </p>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="pricing-list-bottom">
            <div class="container max-width">
                <div class="panel">
                    <mat-expansion-panel (click)="addDataLayerClicProducto(1)" id="ver_plan_persona_fin" hideToggle>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <p>VER PLANES Y CONTRATAR</p>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="content-panel">

                        </div>
                    </mat-expansion-panel>
                </div>
                <div class="panel">
                    <mat-expansion-panel (click)="addDataLayerClicProducto(2)" id="ver_plan_empresa_fin" hideToggle>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <p>VER PLANES Y CONTRATAR</p>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="content-panel">

                        </div>
                    </mat-expansion-panel>
                </div>
            </div>
        </div>

        <div class="clients">
            <p class="title">
                Ellos ya usan <span>Firma Autógrafa Digital</span>
            </p>
            <div class="clients-images max-width">

                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/1-A_C Contruccion.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/2-logo-abc-capital.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/3-logo-abisa.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/5-acil-mexico.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/6-acium.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/7-Actinver.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/8-advex.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/9-alianza-financiera-social.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/10-logo-alorica.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/11-logo-alpez.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/12-alpha credit.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/13-logo-amda.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/16-amex-corp.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/17-Anfexi.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/18-aplika.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/19-arc-canto.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/20-logo-seguro-bx.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/22-arrendamiento-seguro.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/23-arvizu-benitez.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/24-Aseguranzza.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/25-Aser promotora.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/26-aserta.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/27-ARCA.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/28-logo-asf.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/29-logo-atlas-desarrollos.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/30-logo-atradius.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/31-logo-attendo.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/32-logo-axa-seguros.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/33-logo-ayudate.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/34-logo-aqua-farms.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/35-BAM.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/36-logo-mifel.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/37-Banco BASE.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/38-logo-bancoppel.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/39-bancosol.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/40-logo-bank-america.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/41-logo-bankingly.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/42-banorte.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/43-Banorte casa bolsa.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/44-Banregio.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/45-BC credit.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/46-logo-be-grand.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/47-logo-best-doctors.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/48-logo-blac-solutions.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/49-logo-blic.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/50-logo-blue-services.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/52-Boss.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/53-Boxnsuites.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/54-logo-brada.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/55-logo-britannia.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/57-BX.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/58-Capgemini.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/59-logo-casa-equis.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/60-logo-cementos-moctezuma.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/61-logo-central.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/62-CIBando.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/63-logo-club-de-rentas.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/64-logo-cooperativa-ahorro-credito.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/65-Corporacion multivac.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/66-logo-credenz.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/67-logo-credicaor.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/68-credifiel.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/69-logo-credijusto.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/70-credimon.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/71-logo-credit-suisse.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/72-Creditea.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/73-inversiones cuantico.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/74-logo-dafi.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/75-logo-daimler.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/76-Davivienda.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/77-Dicofra.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/78-DigitNow.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/79-Dycsi.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/80-logo-bebe.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/81-logo-educacion.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/83-logo-engie.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/84-logo-epicbanc.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/85-escuela-idiomas.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/87-logo-fanda.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/88-logo-farmalisto.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/89-logo-fergo.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/90-logo-figlosnte.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/91-Fimeco.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/92-logo-finacciona.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/93-logo-finamex.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/94-Finvivir.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/95-forjadores.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/96-logo-formatres38.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/97-logo-garantia-de-renta.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/98-logo-gas-royal.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/99-gemalto.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/101-logo-gm.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/102-GNP.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/103-Grupak.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/104-logo-grupo-aguacatero.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/105-Grupo Barvis.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/106-Grupo CTP.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/107-logo-empresarial-angeles.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/108-logo-grupo-garsa.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/109-logo-larrarte.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/110-logo-grupo-mk.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/111-logo-grupo-renovables.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/112-logo-tangassi.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/113-logo-grupo-tierra-maya.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/114-logo-veintiuno cero.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/115-logo-vigia.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/116-logo-fintex.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/117-logo-salazar-seguros.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/119-logo-ideaconv.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/120-Impulso distrito.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/121-logo-inmobiliaria.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/122-Invex.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/123-logo-ipack.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/124-logo-jp-morgan.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/125-logo-jubicom.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/126-logo-karum.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/127-Kondinero.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/128-logo-lyl-servicios.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/129-logo-castellana.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/130-Lacerta.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/131-Lanapay.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/132-Lecto.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/133-liceo-britanico.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/134-logo-liftit.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/135-logo-lockton.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/136-logo-maletin-financiero.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/137-logo-maple-respiratory.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/138-logo-marnez.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/140-logo-maslow.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/141-logo-medica-movil.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/142- logo-medworks.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/143-logo-femsa.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/144-Metrocarrier.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/145-Mexidooro.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/147-monex.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/149-Banco Multiva.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/150-logo-mvs-radio.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/151-Natgas.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/152-NewYorkLife.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/153-logo-novo-media.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/154-Oak leasing.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/155-logo-orbia.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/156-logo-pa-despues.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/157-logo-pichincha.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/158-logo-potenciadora.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/159-logo-power-golden.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/161-Proagro.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/162-profuturo.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/163-logo-proton.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/164-prudential.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/165-logo-consultoria-juridica.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/166-logo-red-girasol.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/167-Rilmliving.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/168-logo-roadis.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/169-Rockteck.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/170-logo-santander.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/172-seguros atlas.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/173-logo-seguros-potosi.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/175-servnet.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/177-Sicrea.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/178-logo-soluciones-industriales.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/179-logo-sotiderc.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/181-logo-spt-seguros.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/182-SR pago.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/183-logo-srobredo.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/184-logo-start-credit.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/185-logo-storm-group.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/186-Supplycredit.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/187-Sura.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/188-logo-tcpip.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/189-logo-tec.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/190-Tecsup.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/192-logo-thales.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/194-logo-tintorerias-max.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/196-todo-a-dollar.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/197-logo-torres-corzo.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/198-Toyota.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/199-Tucasaexpress.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/200-Value.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/201-Vantis.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/202-Vavilco.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/203-Vector bolsa.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/204-logo-viac.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/205-Viajes el corte ingles.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/206-logo-vidacel.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/207-logo-vivaness.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/208-logo-vwfs.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/209-logo-yo-dispongo.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/210-logo-zavala-aguilar.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/211-logo-compartamos.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/212-logo-axtelcorp.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/213-GENTERA_logotipo.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/216-logo-globalps.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/217-logo-amado.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/218-logo-fibrax.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/219-naturalle-inter.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/220-quality-copy.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/221-logo-lirmi.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/222-logocg-systems.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/223-logo-4r.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/224-logo-ciclos.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/225-logo-amig.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/226-logo-vip.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/227-logo-hotamsat.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/229-logo-nhit.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/230-logo-koi.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/232-logo-olian.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/233-logo-nova-aluminio.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/234-logo-supercredi.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/236-logo-investockly.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/237-logo-cj-prado.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/238-logo-insignia.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/239-logo-mysourcing.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/241-logo-cemex.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/242-logo-lacuna.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/243-logo-urban-town.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/244-logo-finser.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/246-logo-tu-hogar.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/248-logo-ecomaster.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/249-viena-imoveis.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/250-logo-saucer.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/251-logo-maia.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/252-logo-rodrigo-cesar.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/253-logo-lorian.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/254-logo-colegio-brasileiro.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/255-logo-ambaya.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/256-logo-yastas.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/257-logo-grupo.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/258-logo-micro.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/260-logo-yanapana.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/261-logo-produbanco.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/262-logo-segurosaurora.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/264-logo-lalonja.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/265-logo-unispan.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/268-logo-instituto-barong.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/269-logo-ubicanton.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/271-logo-ektaris.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/272-logo-camargo-agronegocios.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/273-logo-fundacion-social.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/274-logo-crescendo.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/275-logo-zenbyte.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/276-logo-cafeyna.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/277-logo-emprenet.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/279-logo-eldefiar.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/281-logo-dinamica-logistica.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/282-logo-ubiqo.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/283-logo-softvaro.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/284-logo-w2b.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/286-logo-escritorio-ribeiro.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/288-logo-noli-imoveis.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/289-logo-diartrading.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/292-logo-gestacore.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/294-logo-seguridad-total.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/295-logo-hekobi.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/296-logo-nova-select.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/297-logo-educando.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/298-logo-colegio-monte.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/300-logo-jamka.png" alt=""></div>
            </div>
        </div>
    </div>

    <!-- FAD MASIVO RESPONSIVO -->
    <div class="fad-movil" *ngIf=" isMobile === true || isTablet === true ">

        <div class="box-container">
            <div class="title-img">
                <div class="box">
                    <div class="wrapper"></div>
                </div>

                <div class="box-border"></div>

                <div class="box-img">
                    <img class="img-prin" src="assets/images/m/welcome.png">
                </div>

                <div class="box-inv">
                    <div class="wrapper"></div>
                </div>
            </div>

            <div class="content-res">
                <h1>Firma Autógrafa Digital®</h1>
                <img style="margin: 0px auto 10px" width="150px" src="assets/images/FAD-ISO-27001.png" alt="ISO 27001">
                <h2>
                    <p class="title">LA FIRMA DIGITAL <br><span>MÁS CONFIABLE</span><br> DE AMÉRICA LATINA</p>
                </h2>
                <div class="line"></div>
                <p>y probablemente del mundo…</p>
            </div>

            <div class="content-res">
                <p class="title" style="text-align: left; padding: 10px">Países que ya firman con <span>FAD®</span></p>
                <img width="100%" height="auto" src="assets/images/mapa_fad.png" alt="">
            </div>


            <div class="content-general">
                <p class="title-secondary no-space">¿Por qué es <br><span>superior a las demás?</span></p>
            </div>

            <div class="content-video">
                <iframe id="video_romantico_movil" src="https://www.youtube.com/embed/ULKgxe3O32g" frameborder="0"
                        allow="autoplay; encrypted-media"
                        allowfullscreen></iframe>
            </div>

            <div class="img-header">
                <div class="box-middle-top">
                    <div class="content-general"><p class="title-secondary"><span>Firma cualquier</span><br><span>documento</span>
                        desde <br> cualquier lugar</p></div>
                </div>
                <div class="box-middle-down"></div>
                <div class="center">
                    <img src="assets/images/m/phonefirma.png" alt="">
                </div>
            </div>

            <div class="content-general">
                <ul class="content-list square">
                    <li><br>100% legal</li>
                    <p>única firma digital probada en juicios</p>
                    <li><br>100% atribuible</li>
                    <p>sólo tu puedes firmar a tu nombre, nadie más</p>
                    <li><br>100% segura</li>
                    <p>tus documentos firmados jamás serán alterados</p>
                </ul>
            </div>

            <div style="margin: auto; height: 2px; width: 266px; background-color: #DCDCDC;"></div>

            <div class="img-header">
                <div class="content-general">
                    <p class="title-secondary">
                        Para configurar<br><span>un documento
                        <br>para firmar<br>con FAD®</span></p>
                    <br>
                    <p class="solo-debes-ingresar">sólo debes ingresar a:<br>
                        <a href="https://clientes.firmaautografa.com/login"
                           target="_blank">clientes.firmaautografa.com</a>
                    </p>
                    <p class="solo-debes-ingresar">
                        <br>
                        Asegúrate <span>hacerlo desde una computadora de escritorio</span>
                    </p>
                    <img width="320px" style="margin-top: 70px" src="assets/images/clientes-pc.png" alt="">
                </div>
            </div>

            <div class="box-light" id="paquetes">
                <p class="title-secondary" style="color: white"><span>Comienza a firmar</span><br>con FAD® ahora</p>
                <div class="wrapper">
                    <div class="column">
                        <img src="assets/images/m/fadper.png" alt="">
                        <div class="content-column">
                            FAD®<br><span>PERSONAL</span><br>
                            <hr>
                            <hr style="margin: 5px 10%; width: 80%; height: 1px; background: white;">
                            <p class="light">
                                <strong>Incluye proceso patentado:</strong>
                                <br>Videofirma, Videoacuerdo, Constancia de conservación
                            </p>
                            <hr style="margin: 5px 10%; width: 80%; height: 1px; background: white;">
                            <p class="light">
                                <strong>Soporte:</strong>
                                <br>N1 Call center de Lunes a Viernes de 8am a 8pm.
                            </p>
                            <hr style="margin: 5px 10%; width: 80%; height: 1px; background: white;">
                            <p class="light">
                                <strong>Incluye:</strong>
                                <br>Solamente app nativa <br>(iOS y Android)
                                <br><strong style="font-size: 11px">No incluye opción a compra de SDK o API</strong>
                            </p>
                            <hr style="margin: 5px 10%; width: 80%; height: 1px; background: white;">
                            <div class="buttons">
                                <div class="btn-back" (click)="addDataLayerClicProducto(1)">
                                    <p id="ver_plan_persona_movil">
                                        Comprar ahora</p>
                                </div>
                                <div class="btn">
                                    <p (click)="login(false)">Prueba<br>gratis</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="column">
                        <img src="assets/images/m/fademp.png" alt="">
                        <div class="content-column">
                            <p class="red">FAD®<br><span>EMPRESA</span></p>
                            <hr class="hr-red">
                            <hr style="margin: 5px 10%; width: 80%; height: 1px; background: white;">
                            <p class="light">
                                <strong>Incluye proceso patentado:</strong>
                                <br>Videofirma, Videoacuerdo, Constancia de conservación
                            </p>
                            <hr style="margin: 5px 10%; width: 80%; height: 1px; background: white;">
                            <p class="light">
                                <strong>Soporte:</strong>
                                <br>N1 Call center de Lunes a Viernes de 8am a 8pm. (N2 con costo extra)
                            </p>
                            <hr style="margin: 5px 10%; width: 80%; height: 1px; background: white;">
                            <p class="light">
                                <strong>Incluye:</strong>
                                <br>App nativa (iOS y Android) opción a adquirir App Web, SDK y API.
                            </p>
                            <hr style="margin: 5px 10%; width: 80%; height: 1px; background: white;">
                            <div class="buttons">
                                <div class="btn-back" (click)="addDataLayerClicProducto(2)">
                                    <p id="ver_plan_empresa_movil">
                                        Comprar ahora</p>
                                </div>
                                <div class="btn">
                                    <p (click)="login(false)">Prueba<br>gratis</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="content-general">

                <div class="fad-movil">
                    <img src="assets/images/m/comprafad.svg">
                </div>

                <p class="title-secondary left-mov">¿Cómo <br><span>comprar FAD®?</span></p>
                <ul class="content-list none">
                    <div class="icon">
                        <div class="icon8"></div>
                    </div>
                    <li>01 <span>Elige</span></li>
                    <p>entre FAD® Personal o <br>FAD® Empresa</p>
                    <div class="icon">
                        <div class="icon9"></div>
                    </div>
                    <li>02 <span>Selecciona</span></li>
                    <p>la suscripción o paquete</p>
                    <div class="icon">
                        <div class="icon11"></div>
                    </div>
                    <li>03 <span>Indica</span></li>
                    <p>el método de pago que deseas</p>
                    <div class="icon">
                        <div class="icon10"></div>
                    </div>
                    <li>03 <span>Disfruta</span></li>
                    <p>si quieres agregar funcionalidades extra,
                        contactáctanos vía WhatsApp...</p>
                </ul>
            </div>
            <div class="box-inv-comp"></div>
        </div>

        <div class="box-container">

            <div class="content-general">

                <p class="title-secondary left-mov">Conoce las <br><span>funcionales <br>extra de FAD®</span></p>

                <div class="icon">
                    <div class="icon2"></div>
                </div>
                <p class="text"><span>Validación de video acuerdo</span>
                    <br>Comparación entre el rostro durante el video acuerdo y la foto de la ID</p>

                <div class="icon">
                    <div class="icon3"></div>
                </div>
                <p class="text"><span>Validación de video firma</span>
                    <br>Comparación entre el rostro durante la video firma y la foto de la ID</p>

                <div class="icon">
                    <div class="icon4"></div>
                </div>
                <p class="text"><span>Constancia de conservación en Blockchain</span>
                    <br>Constancia escrita en Ethereum que garantiza que el documento firmado no será alterado.</p>

                <div class="icon">
                    <div class="icon5"></div>
                </div>
                <p class="text"><span>Captura de ID</span>
                    <br>Fotografía de documento de identidad por ambos lados</p>

                <div class="icon">
                    <div class="icon6"></div>
                </div>
                <p class="text"><span>OTP vía WhatsApp</span>
                    <br>Envío de código de un solo uso por WhatsApp, para que el firmante abra el documento a firmar en
                    la app FAD®</p>

                <div class="icon">
                    <div class="icon7"></div>
                </div>
                <p class="text"><span>Validación de firma</span>
                    <br>Comparación entre firma plasmada en la ID y la firma hecha con el dedo</p>

                <div class="icon">
                    <div class="icon7"></div>
                </div>
                <p class="text"><span>Versión WEB</span>
                    <br>El firmante puede realizar la firma de documentos desde cualquier navegador móvil sin descargar
                    la aplicación FAD®</p>

                <div class="icon">
                    <div class="icon20"></div>
                </div>
                <p class="text"><span style="color: #a80a34;">Consideraciones importantes</span>
                    <br>1. Para realizar las comparaciones de video acuerdo, videofirma y firma,
                    es necesario adquirir la Captura de identificación. <br>
                    2. Para la compra de Add-Ons solicítalos con tu asesor de ventas
                    con costo extra.</p>
                <div class="content-res">
                    <img src="assets/images/m/telefonos.png" alt="">
                </div>
            </div>

            <div class="box-dark">
                <div class="container">
                    <p class="text">
                        La firma Autógrafa Digital®<br>cumple con<br><br>
                        <span>Leyes modelo de comercio electrónico de UNCITRAL (UN), nuevo reglamento eIDAS, US ESIGN, UETA & ESIGN Act, y más</span>
                    </p>
                </div>
                <div class="boton">
                    <p id="ver_cumplimieno_legal_movil" class="text"
                       [routerLink]="['/cumplimiento-juridico-de-la-firma-digital']">Ver sustento legal</p>
                </div>
            </div>
            <div class="img-top">
                <img src="assets/images/m/videoacuerdoantes.png" alt="">
            </div>

            <div class="content-general" style="margin-top: 120px;">
                <ul class="content-list square">
                    <li><br>100% legal</li>
                    <p>Única firma digital probada en juicios</p>
                    <li><br>3 minutos</li>
                    <p>Tiempo que tardas en firmar con FAD®</p>
                    <li><br>90% ahorro</li>
                    <p>En horas y recursos para procesos de firma</p>
                </ul>
            </div>
            <div class="boton-black">
                <p class="text" (click)="freeTest()">Quiero una prueba gratuita</p>
            </div>
            <br>
        </div>

        <div class="box-container">
            <div class="fad-movil">
                <img src="assets/images/m/fadangel.png">
            </div>
            <div class="content-general">
                <p class="title-secondary">¿Para qué <br><span>puedo usar FAD®?</span></p>
            </div>
            <div style="margin-bottom: 10px">
                <p class="text">
                    <strong>Créditos al consumo</strong><br>
                    Firma para contratación de créditos y tarjetas con videofirma, video de aceptación, geolocalización
                    y constancia de conservación emitida por un tercero autorizado.
                </p>
                <hr class="hr-casos">
                <p class="text">
                    <strong>Procesos de RRHH</strong><br>
                    Contratos laborales, NDAs, recibos de nómina, contrataciones, vacaciones, entre otros; con
                    videofirma y constancia emitida por un tercero autorizado.
                </p>
                <hr class="hr-casos">
                <p class="text">
                    <strong>Pagarés digitales</strong><br>
                    Firma para creación, endoso y cancelación de pagarés con videofirma, video de aceptación,
                    geolocalización y constancia de conservación emitida por un tercero autorizado.
                </p>
                <hr class="hr-casos">
                <p class="text">
                    <strong>Compra - venta</strong><br>
                    Firma para compra, venta o renta de bienes y servicios con videofirma, video de aceptación,
                    geolocalización y constancia de conservación emitida por un tercero autorizado.
                </p>
                <hr class="hr-casos">
            </div>
            <br>
            <div class="boton-black" style="margin: 15px 30px">
                <p id="ver_casos_usos_movil" class="text" (click)="moreUseCases()">Ver más casos de uso</p>
            </div>
            <br>
        </div>

        <div class="box-container">

            <div class="content-general">
                <p class="title-secondary left-mov">Ellos ya usan <br><span>Firma Autógrafa <br> Digital</span></p>
            </div>

            <div class="clients-images">

                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/1-A_C Contruccion.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/2-logo-abc-capital.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/3-logo-abisa.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/5-acil-mexico.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/6-acium.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/7-Actinver.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/8-advex.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/9-alianza-financiera-social.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/10-logo-alorica.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/11-logo-alpez.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/12-alpha credit.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/13-logo-amda.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/16-amex-corp.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/17-Anfexi.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/18-aplika.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/19-arc-canto.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/20-logo-seguro-bx.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/22-arrendamiento-seguro.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/23-arvizu-benitez.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/24-Aseguranzza.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/25-Aser promotora.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/26-aserta.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/27-ARCA.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/28-logo-asf.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/29-logo-atlas-desarrollos.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/30-logo-atradius.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/31-logo-attendo.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/32-logo-axa-seguros.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/33-logo-ayudate.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/34-logo-aqua-farms.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/35-BAM.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/36-logo-mifel.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/37-Banco BASE.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/38-logo-bancoppel.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/39-bancosol.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/40-logo-bank-america.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/41-logo-bankingly.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/42-banorte.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/43-Banorte casa bolsa.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/44-Banregio.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/45-BC credit.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/46-logo-be-grand.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/47-logo-best-doctors.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/48-logo-blac-solutions.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/49-logo-blic.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/50-logo-blue-services.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/52-Boss.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/53-Boxnsuites.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/54-logo-brada.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/55-logo-britannia.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/57-BX.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/58-Capgemini.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/59-logo-casa-equis.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/60-logo-cementos-moctezuma.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/61-logo-central.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/62-CIBando.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/63-logo-club-de-rentas.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/64-logo-cooperativa-ahorro-credito.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/65-Corporacion multivac.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/66-logo-credenz.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/67-logo-credicaor.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/68-credifiel.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/69-logo-credijusto.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/70-credimon.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/71-logo-credit-suisse.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/72-Creditea.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/73-inversiones cuantico.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/74-logo-dafi.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/75-logo-daimler.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/76-Davivienda.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/77-Dicofra.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/78-DigitNow.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/79-Dycsi.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/80-logo-bebe.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/81-logo-educacion.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/83-logo-engie.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/84-logo-epicbanc.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/85-escuela-idiomas.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/87-logo-fanda.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/88-logo-farmalisto.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/89-logo-fergo.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/90-logo-figlosnte.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/91-Fimeco.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/92-logo-finacciona.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/93-logo-finamex.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/94-Finvivir.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/95-forjadores.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/96-logo-formatres38.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/97-logo-garantia-de-renta.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/98-logo-gas-royal.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/99-gemalto.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/101-logo-gm.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/102-GNP.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/103-Grupak.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/104-logo-grupo-aguacatero.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/105-Grupo Barvis.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/106-Grupo CTP.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/107-logo-empresarial-angeles.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/108-logo-grupo-garsa.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/109-logo-larrarte.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/110-logo-grupo-mk.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/111-logo-grupo-renovables.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/112-logo-tangassi.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/113-logo-grupo-tierra-maya.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/114-logo-veintiuno cero.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/115-logo-vigia.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/116-logo-fintex.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/117-logo-salazar-seguros.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/119-logo-ideaconv.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/120-Impulso distrito.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/121-logo-inmobiliaria.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/122-Invex.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/123-logo-ipack.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/124-logo-jp-morgan.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/125-logo-jubicom.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/126-logo-karum.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/127-Kondinero.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/128-logo-lyl-servicios.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/129-logo-castellana.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/130-Lacerta.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/131-Lanapay.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/132-Lecto.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/133-liceo-britanico.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/134-logo-liftit.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/135-logo-lockton.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/136-logo-maletin-financiero.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/137-logo-maple-respiratory.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/138-logo-marnez.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/140-logo-maslow.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/141-logo-medica-movil.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/142- logo-medworks.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/143-logo-femsa.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/144-Metrocarrier.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/145-Mexidooro.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/147-monex.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/149-Banco Multiva.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/150-logo-mvs-radio.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/151-Natgas.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/152-NewYorkLife.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/153-logo-novo-media.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/154-Oak leasing.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/155-logo-orbia.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/156-logo-pa-despues.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/157-logo-pichincha.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/158-logo-potenciadora.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/159-logo-power-golden.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/161-Proagro.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/162-profuturo.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/163-logo-proton.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/164-prudential.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/165-logo-consultoria-juridica.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/166-logo-red-girasol.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/167-Rilmliving.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/168-logo-roadis.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/169-Rockteck.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/170-logo-santander.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/172-seguros atlas.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/173-logo-seguros-potosi.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/175-servnet.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/177-Sicrea.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/178-logo-soluciones-industriales.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/179-logo-sotiderc.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/181-logo-spt-seguros.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/182-SR pago.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/183-logo-srobredo.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/184-logo-start-credit.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/185-logo-storm-group.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/186-Supplycredit.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/187-Sura.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/188-logo-tcpip.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/189-logo-tec.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/190-Tecsup.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/192-logo-thales.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/194-logo-tintorerias-max.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/196-todo-a-dollar.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/197-logo-torres-corzo.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/198-Toyota.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/199-Tucasaexpress.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/200-Value.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/201-Vantis.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/202-Vavilco.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/203-Vector bolsa.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/204-logo-viac.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/205-Viajes el corte ingles.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/206-logo-vidacel.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/207-logo-vivaness.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/208-logo-vwfs.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/209-logo-yo-dispongo.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/210-logo-zavala-aguilar.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/211-logo-compartamos.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/212-logo-axtelcorp.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/213-GENTERA_logotipo.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/216-logo-globalps.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/217-logo-amado.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/218-logo-fibrax.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/219-naturalle-inter.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/220-quality-copy.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/221-logo-lirmi.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/222-logocg-systems.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/223-logo-4r.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/224-logo-ciclos.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/225-logo-amig.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/226-logo-vip.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/227-logo-hotamsat.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/229-logo-nhit.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/230-logo-koi.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/232-logo-olian.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/233-logo-nova-aluminio.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/234-logo-supercredi.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/236-logo-investockly.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/237-logo-cj-prado.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/238-logo-insignia.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/239-logo-mysourcing.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/241-logo-cemex.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/242-logo-lacuna.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/243-logo-urban-town.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/244-logo-finser.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/246-logo-tu-hogar.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/248-logo-ecomaster.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/249-viena-imoveis.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/250-logo-saucer.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/251-logo-maia.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/252-logo-rodrigo-cesar.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/253-logo-lorian.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/254-logo-colegio-brasileiro.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/255-logo-ambaya.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/256-logo-yastas.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/257-logo-grupo.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/258-logo-micro.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/260-logo-yanapana.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/261-logo-produbanco.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/262-logo-segurosaurora.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/264-logo-lalonja.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/265-logo-unispan.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/268-logo-instituto-barong.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/269-logo-ubicanton.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/271-logo-ektaris.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/272-logo-camargo-agronegocios.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/273-logo-fundacion-social.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/274-logo-crescendo.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/275-logo-zenbyte.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/276-logo-cafeyna.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/277-logo-emprenet.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/279-logo-eldefiar.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/281-logo-dinamica-logistica.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/282-logo-ubiqo.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/283-logo-softvaro.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/284-logo-w2b.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/286-logo-escritorio-ribeiro.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/288-logo-noli-imoveis.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/289-logo-diartrading.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/292-logo-gestacore.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/294-logo-seguridad-total.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/295-logo-hekobi.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/296-logo-nova-select.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/297-logo-educando.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/298-logo-colegio-monte.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/300-logo-jamka.png" alt=""></div>
            </div>
        </div>
    </div>

</app-template>

<div class="container-ie" *ngIf="isIEOrEdge">
    <div class="data">
        <div class="title">
            <p>NAVEGADOR NO COMPATIBLE</p>
        </div>
        <div class="description">
            <p>
                Intenta probando con un navegador más actual.
            </p>
        </div>
        <img src="assets/images/no-compatible.png" alt="">
    </div>
</div>
